/**
 * Account onboarding (`/account/onboarding`): minimal logo header via
 * `OnboardingAccountHeader`, same NFIB marketing footer as elsewhere but
 * footer Join Now is suppressed (`NfibComFooter` `hideJoinNow`).
 */
export function isOnboardingAccountPath(pathname) {
  return typeof pathname === 'string' && pathname.includes('/account/onboarding');
}



// WEBPACK FOOTER //
// ./src/common/components/Layout/layoutPathUtils.js